import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import './utils'
import './registerServiceWorker'
import './mixins'
import vuetify from './plugins/vuetify'
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import hcMore from "highcharts/highcharts-more";

hcMore(Highcharts);

HighchartsNoData(Highcharts);
Vue.use(HighchartsVue, { Highcharts });

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
